import {
    ActivityStatus,
    ActivityStatusClassification,
    ActivityStatusVisualization
} from 'src/types/activity/activityEnums';
import { dateFormatter } from '../formatters/dateFormatter';
import {getValueInDictionaryIfExists} from "../helpers/dictionaryHelper";


type IEnumActivityStatusVisualizationTo<R> = {[key in keyof typeof ActivityStatusVisualization]: R };
type IEnumActivityStatusClassificationTo<R> = {[key in keyof typeof ActivityStatusClassification]: R };
type IEnumActivityStatusTo<R> = {[key in keyof typeof ActivityStatus]: R };

const dictionaryActivityStatusVisualizationByColor : IEnumActivityStatusVisualizationTo<string> = {
    Vencidas: "#ea1c18",
    AVencer: "#eab000",
    Futuras: "#3f9ce8",
    Realizadas: "#7eb73d"
}

const dictionaryActivityStatusClassificationByColor : IEnumActivityStatusClassificationTo<string> = {
    Pendiente: "#eab000",
    Finalizada: "#7eb73d",
    Anulada: "#ea1c18",
    Vencida: "#ea1c18",
    Futura: "#3f9ce8"
}

const dictionaryActivityStatusByColor : IEnumActivityStatusTo<string> = {
    ConSeguimiento_Anulada: "#ea1c18",

    ConSeguimiento_EnCurso: "#3f9ce8",

    ConSeguimiento_Resuelta: "#7eb73d",
    ConSeguimiento_Finalizada: "#7eb73d",

    ConSeguimiento_Pendiente: "#eab000",
    ConSeguimiento_MasInformacion: "#eab000"
}

export const getActivityStatusVisualizationColor = (codActivityStatusVisualization: number) =>
    getValueInDictionaryIfExists(ActivityStatusVisualization[codActivityStatusVisualization], dictionaryActivityStatusVisualizationByColor);

    
export const getActivityStatusClassificationColor = (codActivityStatusClassification: number, expirationDate: Date | null | undefined) => {

    if (codActivityStatusClassification === ActivityStatusClassification.Pendiente) {
        const actualDate : Date = new Date(new Date().setHours(0,0,0,0));
        const nextWeek : Date = new Date(actualDate.getDate() + 5);
        const shortDateExpire : string = dateFormatter.toISOShortDate(expirationDate || null);
        const dateExpire : Date = (shortDateExpire !== "") ? new Date(shortDateExpire) : new Date();

        if (dateExpire < actualDate)
            codActivityStatusClassification = ActivityStatusClassification.Vencida;
        else if (dateExpire > nextWeek)
            codActivityStatusClassification = ActivityStatusClassification.Futura;
    }

    return getValueInDictionaryIfExists(ActivityStatusClassification[codActivityStatusClassification], dictionaryActivityStatusClassificationByColor);
};

export const getActivityStatusColor = (codActivityStatus: number) =>
    getValueInDictionaryIfExists(ActivityStatus[codActivityStatus], dictionaryActivityStatusByColor);

    